export interface AdminUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  balance: number;
  kyc: 'verified' | 'pending' | 'rejected';
  status: 'active' | 'locked';
  joined: string;
}

export const adminUsers: AdminUser[] = [
  { id: 'u1', name: 'Nguyễn Văn An', email: 'an.nguyen@gmail.com', phone: '0901234567', balance: 520000000, kyc: 'verified', status: 'active', joined: '12/03/2026' },
  { id: 'u2', name: 'Trần Thị Bích', email: 'bich.tran@gmail.com', phone: '0912345678', balance: 180000000, kyc: 'pending', status: 'active', joined: '25/04/2026' },
  { id: 'u3', name: 'Lê Hoàng Minh', email: 'minh.le@gmail.com', phone: '0923456789', balance: 920000000, kyc: 'verified', status: 'active', joined: '03/02/2026' },
  { id: 'u4', name: 'Phạm Quốc Bảo', email: 'bao.pham@gmail.com', phone: '0934567890', balance: 45000000, kyc: 'rejected', status: 'locked', joined: '18/05/2026' },
  { id: 'u5', name: 'Vũ Thị Hồng', email: 'hong.vu@gmail.com', phone: '0945678901', balance: 760000000, kyc: 'verified', status: 'active', joined: '07/01/2026' },
];